import React from 'react';

const BannerSlider = ({ slides = [] }) => {
  const normalizedSlides = slides.length ? slides : [{ label: 'IMAGE' }];
  const defaultColumns = normalizedSlides.map(() => '1fr').join(' ');
  const hoverRules = normalizedSlides
    .map((_, hoverIndex) => {
      const columns = normalizedSlides
        .map((__, index) => (index === hoverIndex ? '2fr' : '0.5fr'))
        .join(' ');
      const grayscaleRules = normalizedSlides
        .map((__, index) =>
          index === hoverIndex
            ? `.banner-grid:has(.banner-panel-${hoverIndex}:hover) .banner-img-${index}{filter:grayscale(0);}`
            : `.banner-grid:has(.banner-panel-${hoverIndex}:hover) .banner-img-${index}{filter:grayscale(1);}`
        )
        .join('');
      return `.banner-grid:has(.banner-panel-${hoverIndex}:hover){grid-template-columns:${columns};}${grayscaleRules}`;
    })
    .join('');

  return (
    <>
      <style>{`.banner-grid{grid-template-columns:${defaultColumns};}${hoverRules}`}</style>
      <div className="banner-grid relative w-full h-full overflow-hidden grid gap-[2px] transition-[grid-template-columns] duration-300">
        {normalizedSlides.map((slide, index) => (
          <div
            key={`${slide.label || 'slide'}-${index}`}
            className={`banner-panel-${index} relative h-full overflow-hidden group/banner`}
          >
            {slide.src ? (
              <img
                src={slide.src}
                alt={slide.alt || slide.label || `Slide ${index + 1}`}
                className={`w-full h-full object-cover transition-all duration-700 banner-img-${index}`}
              />
            ) : (
              <div className="w-full h-full bg-gray-300 flex items-center justify-center grayscale transition duration-300 group-hover/banner:grayscale-0">
                <span className="text-gray-600 font-bold text-sm tracking-widest">
                  {slide.label || `IMAGE ${index + 1}`}
                </span>
              </div>
            )}
          </div>
        ))}
      </div>
    </>
  );
};

export default BannerSlider;
